import { render, staticRenderFns } from "./his.vue?vue&type=template&id=3345de62&scoped=true&"
import script from "./his.vue?vue&type=script&lang=js&"
export * from "./his.vue?vue&type=script&lang=js&"
import style0 from "./his.vue?vue&type=style&index=0&id=3345de62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345de62",
  null
  
)

export default component.exports